import React from 'react';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';

import SubmitButton from '../Forms/SubmitButton/index.jsx';

import Spinner from '../Spinner/index.jsx';

import FormField from './form-field.jsx';

import RestClient from '@scripts/utilities/rest-client.js';


class EnableTwoFactor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      validated: false,
      error: '',
      qrCode: '',
      qrCodeValidation: ''
    };

    this.onError = this.onError.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.onQrCodeChange = this.onQrCodeChange.bind(this);
  }

  onError(error) {
    this.setState({ loading: false, error: error.message });
  }

  onSubmit(event) {
    event.preventDefault();

    var newState = { validated: true, error: undefined };
    var form = event.currentTarget;
    var formData = {};

    // validate the form.
    var submitForm = true;
    var code = form.elements['code'];
    formData.code = code.value;
    newState.qrCodeValidation = this.validateQrCode(code);
    if (newState.qrCodeValidation) {
      submitForm = false;
    }

    if (submitForm) {
      newState.loading = true;

      if (this.props.onSubmit) {
        this.props.onSubmit(formData)
          .then(this.onSuccess)
          .catch(this.onError);
      }
    }

    this.setState(newState);
  }

  onSuccess() {
    // reset the form
    this.setState({
      loading:  false,
      validated:  false,
      qrCode:  '',
      error:  ''
    });
  }

  onQrCodeChange(event) {
    this.setState({
      qrCode: event.target.value,
      qrCodeValidation: this.validateQrCode(event.target)
    });
  }

  validateQrCode(input) {
    var error;
    if (! input.checkValidity()) {
      error = input.validationMessage;
    }

    return error;
  }

  render() {
    var content = [];
    var error;

    if (this.state.error) {
      error = (
        <Alert key="danger" variant="danger">
          <Alert.Heading>Error:</Alert.Heading>
          {this.state.error}
        </Alert>
      );
    }

    content.push(
      <div className="wp-block-image">
        <figure>
          <img
            loading="lazy"
            src={this.props.qrCode}
            alt="Two Factor Authentication QR Code"
          />
        </figure>
      </div>
    );
    content.push(
      <p key="info">
	Scan the above QR code with your authenticator app, such as Google Authenticator or Authy. Alternatively, you may manually enter your secret key: <code>{this.props.secret}</code>
      </p>
    );

    content.push(
      <div key="form" className="cs-block-form">
        {error}
        <Form noValidate onSubmit={this.onSubmit}>
          <FormField
            id="code"
            name="code"
            type="text"
            required
            value={this.state.qrCode}
            onChange={this.onQrCodeChange}
            validated={this.state.validated}
            validationMessage={this.state.qrCodeValidation}
            label="Verification Code"
            helpText="Enter the code you received after scanning the QR code"
          />
          <SubmitButton loading={this.state.loading}>
            Enable 2FA
          </SubmitButton>
        </Form>
      </div>
    );


    return content;
  }
}


class DisableTwoFactor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: '',
      loading: false,
      validated: false,
      currentPassword: '',
      currentPasswordValidation: ''
    };

    this.onError = this.onError.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCurrentPasswordChange = this.onCurrentPasswordChange.bind(this);
  }

  validateCurrentPassword(input) {
    var error;
    if (! input.checkValidity()) {
      error = input.validationMessage;
    }

    return error;
  }

  onCurrentPasswordChange(event) {
    this.setState({
      currentPassword: event.target.value,
      currentPasswordValidation: this.validateCurrentPassword(event.target)
    });
  }

  onError(error) {
    this.setState({ loading: false, error: error.message });
  }

  onSubmit(event) {
    event.preventDefault();

    var newState = { validated: true, error: undefined, success: undefined };
    var form = event.currentTarget;
    var formData = {};

    // validate the form.
    var submitForm = true;
    var currentPassword = form.elements['current-password'];
    formData.currentPassword = currentPassword.value;
    newState.currentPasswordValidation = this.validateCurrentPassword(currentPassword);
    if (newState.currentPasswordValidation) {
      submitForm = false;
    }


    if (submitForm) {
      newState.loading = true;

      if (this.props.onSubmit) {
        this.props.onSubmit(formData)
          .then(this.onSuccess)
          .catch(this.onError);
      }
    }

    this.setState(newState);
  }

  onSuccess() {
    // reset the form
    this.setState({
      loading:  false,
      validated:  false,
      currentPassword:  '',
      error:  ''
    });
  }

  render() {
    var content = [];
    var error;

    if (this.state.error) {
      error = (
        <Alert key="danger" variant="danger">
          <Alert.Heading>Error:</Alert.Heading>
          {this.state.error}
        </Alert>
      );
    }

    content.push(
      <p key="intro">In order to disable 2FA, please enter your current password.</p>
    );
    content.push(
      <div key="form" className="cs-block-form">
        {error}
        <Form noValidate onSubmit={this.onSubmit}>
          <FormField
            id="current-password"
            name="current-password"
            type="password"
            required
            value={this.state.currentPassword}
            onChange={this.onCurrentPasswordChange}
            validated={this.state.validated}
            validationMessage={this.state.currentPasswordValidation}
            label="Current Password"
          />
          <SubmitButton loading={this.state.loading}>
            Disable 2FA
          </SubmitButton>
        </Form>
      </div>
    );


    return content;
  }
}


class TwoFactorAuthentication extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: undefined,
      success: undefined,
      enabled: false,
      secret: undefined,
      qrCode: undefined
    };

    this.onError = this.onError.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.onTwoFactorSubmit = this.onTwoFactorSubmit.bind(this);
  }

  onError(error) {
    this.setState({ loading: false, error: error.message, success: undefined });
  }

  onTwoFactorSubmit(formData) {
    return RestClient.post('/wp-json/sbm/v1/user/2fa/', formData)
      .then(this.onSuccess);
  }

  onSuccess(response) {
    var newState = {};

    newState.loading =  false;
    newState.success =  undefined;
    newState.error =  undefined;

    newState.enabled = response.enabled;
    newState.secret = response.secret;
    newState.qrCode = response.qrCode;

    if (! this.state.loading) {
      if (newState.enabled) {
        newState.success = '2FA has been enabled.';
      } else {
        newState.success = '2FA has been disabled.';
      }
    }

    // reset the form
    this.setState(newState);
  }

  componentDidMount() {
    RestClient.get('/wp-json/sbm/v1/user/2fa/')
      .then(this.onSuccess)
      .catch(this.onError);
  }

  render() {
    var error;
    var success;

    if (this.state.success) {
      success = (
        <Alert key="success" variant="success">
          <Alert.Heading>Success:</Alert.Heading>
          {this.state.success}
        </Alert>
      );
    }
    if (this.state.error) {
      error = (
        <Alert key="danger" variant="danger">
          <Alert.Heading>Error:</Alert.Heading>
          {this.state.error}
        </Alert>
      );
    }

    var content = [];
    content.push(
      <h3 key="title">Two-Factor Authentication</h3>
    );
    content.push(success);
    content.push(error);
    if (this.state.loading) {
      content.push(
        <Spinner key="spinner" />
      );
    } else {
      if (this.state.enabled) {
        content.push(
          <p key="status"><strong>2FA is currently enabled on your account.</strong></p>
        );
        content.push(
          <DisableTwoFactor key="content" onSubmit={this.onTwoFactorSubmit} />
        );
      } else {
        content.push(
          <p key="status"><strong>2FA is not enabled on your account.</strong></p>
        );
        content.push(
          <EnableTwoFactor
            key="content"
            qrCode={this.state.qrCode}
            secret={this.state.secret}
            onSubmit={this.onTwoFactorSubmit}
          />
        );
      }
    }


    return content;
  }
}


export default TwoFactorAuthentication;

